import actionType from "./actionTypes";
import initialState from "./initialState";


const employeeReducer = (state = initialState, action) => {
  switch (action.type) {
    
    case actionType.INITIAL_FEDEX_TRACK:
    return {
      ...state,
      fedexTrackingStatus: false
    };
    case actionType.ADMIN_EDIT_COST_DETAILS_SUCCESS:
      return {
        ...state,
        adminEditCostDetailsData: action.payload,
        adminEditCostDetailsStatus: true
      };
    case actionType.ADMIN_EDIT_COST_DETAILS_FAILURE:
      return {
        ...state,
        adminEditCostDetailsStatus: false
      };
    case actionType.FACILITY_REG_STATUS_CHANGE_SUCCESS:
      return {
        ...state,
        facilityRegStatusChange: true,
        message: action.message
      };
    case actionType.FACILITY_REG_STATUS_CHANGE_FAILURE:
      return {
        ...state,
        facilityRegStatusChange: false,
        message: action.message,
      };

    case actionType.GET_BAA_IMAGE_SUCCESS:
      return {
        ...state,
        getBaaImage: action.payload,
        getBaaImageStatus: true,
        message: action.message
      };
    case actionType.GET_BAA_IMAGE_FAILURE:
      return {
        ...state,
        getBaaImageStatus: false,
        message: action.message,
      };

    case actionType.GET_NEW_FACILITY_LIST_SUCCESS:
      return {
        ...state,
        getNewFacilityListData: action.payload,
        getNewFacilityListStatus: true,
        message: action.message
      };
    case actionType.GET_NEW_FACILITY_LIST_FAILURE:
      return {
        ...state,
        getNewFacilityListStatus: false,
        message: action.message,
        getNewFacilityListData: { facilityRequestObj: [] },
      };

    case actionType.GET_FACILITY_LIST_SUCCESS:
      return {
        ...state,
        getFacilityListData: action.payload,
        getFacilityListStatus: true,
        message: action.message
      };
    case actionType.GET_FACILITY_LIST_FAILURE:
      return {
        ...state,
        getFacilityListStatus: false,
        message: action.message,
      };
    case actionType.RECORD_REQ_LIST_SUCCESS:
      return {
        ...state,
        adminEditCostDetailsStatus: false,
        fedexTrackingStatus: false,
        finalCostStatus: false,
        viewRequestInfoStatus: false,
        getRecordReqListData: action.payload,
        getRecordReqStatus: true,
        finalCostForViewStatus: false,
        message: action.message
      };
    case actionType.RECORD_REQ_LIST_FAILURE:
      return {
        ...state,
        fedexTrackingStatus: false,
        getRecordReqStatus: false,
        message: action.message
      };

    case actionType.FINAL_COST_SUCCESS:
      return {
        ...state,
        finalCostStatus: true,
        finalCostDetails: action.payload,
        message: action.message
      };
    case actionType.FINAL_COST_FAILURE:
      return {
        ...state,
        finalCostStatus: false,
        message: action.message
      };
    case actionType.ASSIGN_EMPLOYEE_STATUS_SUCCESS:
      return {
        ...state,
        finalCostStatus: false,
        assignEmpStatus: true,
        message: action.message
      };
    case actionType.ASSIGN_EMPLOYEE_STATUS_FAILURE:
      return {
        ...state,
        assignEmpStatus: false,
        message: action.message
      };
    case actionType.FEDEX_TRACKING_SUCCESS:
      return {
        ...state,
        fedexTrackingStatus: true,
        fedexTrakingDetails: action.payload,
        message: action.message
      };

    case actionType.FEDEX_TRACKING_FAILURE:
      return {
        ...state,
        fedexTrackingStatus: false,
        message: action.message
      };

    case actionType.FEDEX_STATUS_CHANGE:
      return {
        ...state,
        fedexTrackingStatus: false,
      };
    case actionType.CHECK_FAXSTATUS_SUCCESS:
      return {
        ...state,
        checkFaxstatus: true,
        checkFaxdetails: action.payload,
        message: action.message
      };
    case actionType.CHECK_FAXSTATUS_FAILURE:
      return {
        ...state,
        checkFaxstatus: false,
        message: action.message
      };
    case actionType.FAX_STATUS_CHANGE:
      return {
        ...state,
        checkFaxstatus: false,

      };
    case actionType.DOWNLOAD_RECORDS_SUCCESS:
      return {
        ...state,
        downloadRecordService: true,
        downloadRecordDetails: action.payload
      };
    case actionType.DOWNLOAD_RECORDS_FAILURE:
      return {
        ...state,
        downloadRecordService: false,
      };
    case actionType.DOWNLOAD_STATUS_CHANGE:
      return {
        ...state,
        downloadRecordService: false,
      };
    case actionType.FAX_RESEND_SUCCESS:
      return {
        ...state,
        resendFaxStatus: true,
        resendFaxDetails: action.payload,
      };
    case actionType.FAX_RESEND_FAILURE:
      return {
        ...state,
        resendFaxStatus: false,
      };


    case actionType.FACILITY_EMR_LIST_SUCCESS:
      return {
        ...state,
        facilitySettingStatus: true,
        facilitySettingDetails: action.payload
      };
    case actionType.FACILITY_EMR_LIST_FAILURE:
      return {
        ...state,
        facilitySettingStatus: false,
      };

    case actionType.FINALCOST_FOR_VIEW_SUCCESS:
      return {
        ...state,
        finalCostForViewStatus: true,
        finalCostForViewDetails: action.payload
      };
    case actionType.FINALCOST_FOR_VIEW_FAILURE:
      return {
        ...state,
        finalCostForViewStatus: false,
      };
    case actionType.REFRESH_COST_STATUS_FALSE:
      return {
        ...state,
        finalCostForViewStatus: false,
      };
    default:
      return state;
  }
};
export default employeeReducer;